import { NgModule }               from '@angular/core';
import { RouterModule }           from '@angular/router';

import { dashboardRoutes }        from './dashboard-routes';

@NgModule({
  imports: [RouterModule.forChild(dashboardRoutes)],
  exports: [ RouterModule ]
})

export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard-routing.module.ts